
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'どのモールに対応していますか？',
      answer: '楽天市場、Amazon、Yahoo!ショッピング、自社EC（Shopify、BASE等）、eBay、メルカリShopsなど、主要なECモールに対応しています。API連携やCSV出力に対応しているモールであれば、ほぼすべて自動化可能です。'
    },
    {
      question: 'スプレッドシートが苦手でも大丈夫ですか？',
      answer: '問題ありません。弊社が設計・構築したスプレッドシートは、必要な箇所に入力するだけで自動計算される仕組みになっています。複雑な関数や操作は不要で、Excelの基本操作ができれば十分にご利用いただけます。'
    },
    {
      question: '既存の運用を壊さず移行できますか？',
      answer: 'はい、段階的な移行が可能です。まず診断フェーズで現状を把握し、優先度の高い業務から順に自動化していきます。既存の運用を継続しながら、並行して新しい仕組みをテストし、問題がないことを確認してから完全移行します。'
    },
    {
      question: 'どこまで自動化できますか？',
      answer: 'データ処理や計算、CSV生成、在庫同期など、ルール化できる業務はほぼすべて自動化可能です。ただし、商品写真の撮影や、クリエイティブな判断が必要な業務は人の手が必要です。診断時に自動化可能な範囲を明確にご提示します。'
    },
    {
      question: '社内にエンジニアがいなくても大丈夫ですか？',
      answer: '全く問題ありません。構築後の運用は、スプレッドシートの基本操作ができれば十分です。また、運用顧問プランをご契約いただければ、システムの改善や追加自動化も継続的にサポートいたします。'
    }
  ];

  return (
    <section id="faq" className="py-16 md:py-24 bg-white">
      <div className="max-w-[900px] mx-auto px-6 md:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900">
            よくある<strong className="text-primary">ご質問</strong>
          </h2>
        </div>
        
        <div className="space-y-3 md:space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-xl overflow-hidden hover:border-primary/30 transition-colors"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-4 md:px-6 py-4 md:py-5 flex items-center justify-between gap-3 md:gap-4 text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-center gap-3 md:gap-4 flex-1">
                  <div className="w-8 h-8 md:w-10 md:h-10 bg-primary text-white rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="font-bold text-sm md:text-base">Q</span>
                  </div>
                  <span className="font-bold text-gray-900 text-sm md:text-lg">
                    {faq.question}
                  </span>
                </div>
                <i
                  className={`ri-arrow-down-s-line text-xl md:text-2xl text-gray-400 transition-transform flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              
              {openIndex === index && (
                <div className="px-4 md:px-6 pb-4 md:pb-6 pl-14 md:pl-20 bg-gray-50">
                  <p className="text-gray-700 leading-relaxed text-xs md:text-base">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
